import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListCard from "./ListCard";
import BorderedBtn from "../FacilityBorderedBtn";
import SearchModal, { DisplayState, SearchState } from "../SearchModal";
import { SonicFacilityData } from "../../../common/classes/SonicFacility";
// import { SonicTopicsData } from "../../../common/classes/SonicTopics";
import LoadingSpinner from "../../../common/LoadingSpinner";
import serviceLogo from "../../../assets/img/logo.svg";
import styles from "./FacilityTop.module.scss";
import UserContact from "../UserContact";
import ContactBanner from "../ContactBanner";
import { sendEventTracking } from "../../../utils/GeneralUtils";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  newFacilities: SonicFacilityData[];
  recommends: SonicFacilityData[];
  recommendText: string;
  // reports: SonicTopicsData[];
  isLoading: boolean;
  keyword: string;
  handleKeyword: (value: string) => void;
  handleSearchFunc: (args: SearchState) => void;
  clearSearch: () => void;
  searchArgs: SearchState;
};

const FacilityTop: React.FC<Props> = ({
  newFacilities,
  recommends,
  recommendText,
  // reports,
  isLoading,
  keyword,
  handleKeyword,
  handleSearchFunc,
  clearSearch,
  searchArgs,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [displayState, setDisplayState] = useState<DisplayState>(
    DisplayState.None
  );

  if (isLoading) return <LoadingSpinner space={1} />;

  return (
    <div className={styles["f-facilityTop"]}>
      <div className={styles["f-facilityTop__head"]}>
        <div className={styles["container-360"]}>
          <div className={styles["f-facilityTop__head-img"]}>
            <div className={styles["imgBox"]}>
              {/* TODO 画像表示 */}
              <img src={serviceLogo} alt="SELeCTロゴ" />
            </div>
            <p>CAFE BASE</p>
            <h2>あなたぴったりのeスポーツ施設が見つかる</h2>
          </div>
          <div className={styles["f-facilityTop__head-search"]}>
            <BorderedBtn
              icon={["fas", "magnifying-glass"]}
              onClick={() => setModalOpen(true)}
            />
          </div>
          <Title title="AREA SEARCH" sub="都道府県検索" />
          <div className={styles["f-facilityTop__head-prefecture"]}>
            <div className={styles["f-facilityTop__head-prefecture__grid"]}>
              <BorderedBtn
                text="東京"
                onClick={() => {
                  handleSearchFunc({
                    prefecture: ["東京都"],
                    hostEvents: "",
                    foodService: "",
                    smoking: "",
                  });
                }}
              />
              <BorderedBtn
                text="神奈川"
                onClick={() => {
                  handleSearchFunc({
                    prefecture: ["神奈川県"],
                    hostEvents: "",
                    foodService: "",
                    smoking: "",
                  });
                }}
              />
              <BorderedBtn
                text="千葉"
                onClick={() => {
                  handleSearchFunc({
                    prefecture: ["千葉県"],
                    hostEvents: "",
                    foodService: "",
                    smoking: "",
                  });
                }}
              />
              <BorderedBtn
                text="埼玉"
                onClick={() => {
                  handleSearchFunc({
                    prefecture: ["埼玉県"],
                    hostEvents: "",
                    foodService: "",
                    smoking: "",
                  });
                }}
              />
            </div>
            <BorderedBtn
              text="都道府県を選ぶ"
              onClick={() => {
                setModalOpen(true);
                setDisplayState(DisplayState.Prefcture);
              }}
            />
          </div>
        </div>
      </div>
      <div className={styles["f-facilityTop__content-area"]}>
        <>
          <div
            className={`${styles["f-facilityTop__content-head"]} ${styles["concave"]}`}
          ></div>
          <div
            className={`${styles["f-facilityTop__content"]} ${styles["container-1280"]}`}
          >
            <Title
              title="NEW ARRIVAL"
              sub="新規掲載施設"
              desc="新しく登録されたeスポーツカフェです"
            />
            <ul>
              {newFacilities.map((f) => (
                <ListCard
                  key={f.id}
                  id={f.id}
                  name={f.name}
                  img={f.imgs && f.imgs[0] ? f.imgs[0] : undefined}
                  prefecture={f.prefecture}
                  onClick={() =>
                    sendEventTracking("click", "FacilityTop-Latest", f.name)
                  }
                />
              ))}
            </ul>
            <SonicLink to="/facility/list">
              <span>もっと見る</span>
              <FontAwesomeIcon icon={["fal", "chevron-right"]} />
            </SonicLink>
          </div>
        </>

        <>
          {recommends && recommends.length ? (
            <>
              <div
                className={`${styles["f-facilityTop__content-head"]} ${styles["convex"]}`}
              ></div>
              <div
                className={`${styles["f-facilityTop__content"]} ${styles["container-1280"]}`}
              >
                <Title
                  title="RECOMMENDED"
                  sub="おすすめ施設"
                  desc={recommendText}
                />
                <ul>
                  {recommends.map((r) => (
                    <ListCard
                      key={r.id}
                      id={r.id}
                      name={r.name}
                      img={r.imgs && r.imgs[0] ? r.imgs[0] : undefined}
                      prefecture={r.prefecture}
                      onClick={() =>
                        sendEventTracking(
                          "click",
                          "FacilityTop-Recommend",
                          r.name
                        )
                      }
                    />
                  ))}
                </ul>
              </div>
            </>
          ) : null}
        </>

        <>
          {/* TODO 施設に関するトピックスの調整時に調整 */}
          {/* {reports && (
        <>
        <div
          className={`${styles["f-facilityTop__content-head"]} ${styles["concave"]}`}
        ></div>
        <div className={`${styles["f-facilityTop__content"]} ${styles["container-1280"]}`}>
          <Title
            title="REPORT"
            sub="施設レポート"
            desc="eスポーツ施設を実際に訪問したレポートをお届け！"
          />
          <ul>
            {reports.map((r) => {
              const text = r.content.blocks.find((b) => b.type === "paragraph");

              return (
                <ListCard
                  key={r.id}
                  id={r.id}
                  name={r.name}
                  img={r.imgs && r.imgs[0] ? r.imgs[0] : undefined}
                  body={text?.data.text}
                />
              );
            })}
          </ul>
        </div>
        </>
      )} */}
        </>
      </div>

      {/* TODO バナー */}
      <div className={styles["f-facilityTop__request"]}>
        <ContactBanner />
      </div>
      <div className={styles["f-facilityTop__notes"]}>
        <UserContact />
      </div>
      {modalOpen && (
        <SearchModal
          searchOpen={modalOpen}
          handleSearchModal={setModalOpen}
          state={displayState}
          keyword={keyword}
          handleKeyword={handleKeyword}
          handleSearchFunc={handleSearchFunc}
          clearSearch={clearSearch}
          searchArgs={searchArgs}
        />
      )}
    </div>
  );
};

export default FacilityTop;

type TitleProps = {
  title: string;
  sub: string;
  desc?: string;
};

const Title: React.FC<TitleProps> = ({ title, sub, desc }) => (
  <div className={styles["f-facilityTop__title"]}>
    <span className={styles["f-facilityTop__title__sub"]}>{sub}</span>
    <h2 className={styles["f-facilityTop__title__main"]}>{title}</h2>
    {desc && <p className={styles["f-facilityTop__title__desc"]}>{desc}</p>}
  </div>
);
